import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

export default function Instructors() {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: "-100px" })

  return (
    <section id="instructors" ref={ref} className="relative bg-[#FDFBF7] dark:bg-neutral-950 py-32 overflow-hidden transition-colors duration-500">
      <div className="container mx-auto px-6 md:px-12 lg:px-20">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          className="mb-20"
        >
          <span className="text-rose-500 font-mono text-xs uppercase tracking-[0.3em] block mb-6">
            Leadership
          </span>
        </motion.div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}
            className="relative"
          >
            <div className="aspect-[3/4] overflow-hidden rounded-2xl">
              <img
                src="/gallery/sudha2.png"
                alt="Dr. Sudha M"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border border-charcoal-200 dark:border-white/10 rounded-2xl -z-10" />
          </motion.div>

          {/* Right - Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.2 }}
          >
            {/* Name */}
            <h2 className="text-6xl md:text-8xl font-serif font-black text-charcoal-900 dark:text-white leading-[0.85] mb-8">
              Dr. Sudha <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-400 to-rose-600">M.</span>
            </h2>

            {/* Title */}
            <div className="mb-12">
              <div className="text-[10px] text-charcoal-400 dark:text-neutral-500 font-mono uppercase tracking-[0.3em] mb-2">Title</div>
              <div className="text-charcoal-900 dark:text-white text-xl">Founder & Lead Instructor</div>
            </div>

            {/* Bio */}
            <p className="text-charcoal-600 dark:text-neutral-300 text-lg leading-relaxed mb-12">
              With a Doctorate in Cosmetology and over 18 years of industry experience,
              Dr. Sudha has trained more than 15,000 makeup artists. Her philosophy centers
              on technical excellence paired with creative freedom.
            </p>

            {/* Credentials */}
            <div className="grid grid-cols-2 gap-8">
              {[
                { label: 'Qualification', value: 'Ph.D in Cosmetology' },
                { label: 'Experience', value: '18+ Years' },
                { label: 'Students', value: '15,000+' },
                { label: 'Certifications', value: 'International' },
              ].map((item, i) => (
                <motion.div
                  key={item.label}
                  initial={{ opacity: 0, y: 20 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ delay: 0.5 + i * 0.1 }}
                >
                  <div className="text-[10px] text-charcoal-400 dark:text-neutral-500 font-mono uppercase tracking-[0.3em] mb-2">
                    {item.label}
                  </div>
                  <div className="text-charcoal-900 dark:text-white font-medium">{item.value}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
